import "./ArticleCard.css";
import { useState, useEffect } from "react";
import { GradeBadge } from "./GRADE/GRADEBadge";
import { Tooltip } from "../Tooltip/Tooltip";
import { getSignedFileUrl } from "../../Utils/functions";

export const ArticleCard = ({
  score,
  title,
  date,
  authors,
  journal,
  insight,
  results,
  citations,
  isPeerReviewed,
  uniqueId,
  index,
  gradeData,
  isPrivate = false,
}) => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [citationLevel, setCitationLevel] = useState("");
  const [showGrades, setShowGrades] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const handleViewPrivateData = async (event, fileId) => {
    event.stopPropagation();
    const orgId = localStorage.getItem("organizationId");
    if (!orgId) return;
    try {
      const url = await getSignedFileUrl(orgId, fileId);
      if (url) {
        window.open(url, "_blank");
      } else {
        setSnackbar({
          open: true,
          message: "File not found.",
          severity: "error",
        });
      }
    } catch (err) {
      setSnackbar({
        open: true,
        message: "Could not fetch file URL.",
        severity: "error",
      });
    }
  };

  useEffect(() => {
    if (citations > 15) {
      setCitationLevel("HighlyCited");
    } else if (citations > 5) {
      setCitationLevel("ModeratelyCited");
    } else {
      setCitationLevel("SparselyCited");
    }
  }, [citations]);

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  const toggleGrades = (e) => {
    e.stopPropagation(); // Prevent the click from propagating to the card
    setShowGrades(!showGrades);
  };

  return (
    <div
      className={`ArticleCard ${isCollapsed ? "collapsed" : ""}`}
      onClick={toggleCollapse}
    >
      <div className="CollapseIcon">{isCollapsed ? "▼" : "▲"}</div>
      <div className="Body">
        <div className="Title">
          {index + 1}. {title}
          {isPrivate && <span className="Badge TrustScore high">Private</span>}
        </div>
        <div className="Container">
          <div
            className="Headervalue"
            style={{ color: "#4a5568", fontWeight: 400, fontFamily: "Inter" }}
          >
            Author(s): {authors[0].split(" ")[authors[0].split(" ").length - 1]}{" "}
            et al.
          </div>
        </div>
        <div className="Container" style={{ flexWrap: "wrap", gap: "5px" }}>
          <Tooltip
            text={
              gradeData?.Calculation_Summary?.toString() ||
              "No summary provided"
            }
          >
            <span
              className={`Badge TrustScore ${gradeData?.Overall_GRADE_Score?.toLowerCase()?.replace(
                / /g,
                "_"
              ) || "not_available"}`}
            >
              GRADE: {gradeData?.Overall_GRADE_Score || "Not available"}
            </span>
          </Tooltip>
          <div className="GradeContainer">
            <button className="toggle-grades" onClick={toggleGrades}>
              {showGrades ? "Hide Details" : "Show Details"}
            </button>
            {showGrades && (
              <>
                {Object.keys(gradeData || {}).map((key) => {
                  if (
                    key !== "Overall_GRADE_Score" &&
                    key !== "Calculation_Summary"
                  ) {
                    const data = gradeData[key];
                    return (
                      <GradeBadge
                        key={key}
                        label={key.replace(/_/g, " ")}
                        Rating={data.Rating}
                        Value={data.Value}
                        Justification={data.Justification}
                      />
                    );
                  }
                })}
              </>
            )}
          </div>
          {/* <span className={`Badge ${citationLevel}`}>
                        {citationLevel.replace('Cited', ' Cited')}
                    </span> */}
          {/* <span className={`Badge TrustScore High`}>
                        <a href={`https://pubmed.ncbi.nlm.nih.gov/${pubmed_id}`} target="_blank" rel="noopener noreferrer">
                            View Full Study
                        </a>
                    </span> */}

          {/* {isPeerReviewed ? (
                        <span className='Badge PeerReviewed'>Peer Reviewed</span>
                    ) : (
                        <span className='Badge NotReviewed'>Not Reviewed</span>
                    )} */}
        </div>
        {!isCollapsed && (
          <>
            <div className="Container">
              <div className="Subheader">Date:</div>
              <div className="Headervalue">{date}</div>
            </div>
            <div className="Container">
              <div className="Subheader">Author(s):</div>
              <div className="Headervalue">
                {typeof authors === "string" ? authors : authors.join(", ")}
              </div>
            </div>
            <div className="Container">
              <div className="Subheader">Journal:</div>
              <div className="Headervalue">{journal}</div>
            </div>
            <div className="Insight">
              <div className="InsightHeader">Key Insights</div>
              <div className="InsightValue">{insight}</div>
            </div>
            <div className="Insight">
              <div className="InsightHeader">Analysis Results</div>
              <div className="InsightValue">{results}</div>
            </div>
            {isPrivate ? (
              <button className="ViewFullStudyButton" 
                onClick={(event) => handleViewPrivateData(event, uniqueId)}
                style={{ cursor: 'pointer'}}
              >View Full Study</button>
            ) : (
              <span className="ViewFullStudyButton">
                <a
                  href={`https://pubmed.ncbi.nlm.nih.gov/${uniqueId}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View Full Study
                </a>
              </span>
            )}
          </>
        )}
      </div>
    </div>
  );
};
